// Zentrale WhatsApp-Konfiguration für die gesamte Landingpage.
// Ändere die Nummer / Nachricht hier an einer Stelle.
export const WHATSAPP_NUMBER = "491728246564";
export const WHATSAPP_PREFILL =
  "Hi! Ich schicke gleich meine aktuelle Rechnung und möchte euer 24h-Angebot.";

export function whatsappUrl(message = WHATSAPP_PREFILL) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

export function trackWaClick(location) {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "whatsapp_click", { location });
  }
}
